export default {
	title: "Informes",
	selectReport: "Seleccione un informe para ver",
	ritualReport: "Informe de Ritual",
	noClosedRituals: "No se encontraron rituales cerrados",
	requiresClosed: "El ritual debe estar cerrado para acceder al informe.",
	closings: {
		title: "Cierres de Rituales",
		description: "Informes detallados de rituales cerrados",
		totalClosed: "Rituales cerrados",
	},
	print: "Imprimir",
	sendEmail: "Enviar por email",
	emailSent: "Informe enviado a su correo",
	emailError: "Error al enviar informe por email",
	printHeader: {
		printedAt: "Impreso en",
	},
	back: "Volver",
	header: {
		type: "Tipo",
		spiritualLine: "Línea Espiritual",
		date: "Fecha",
		location: "Ubicación",
		openedBy: "Abierto por",
		closedBy: "Cerrado por",
	},
	stats: {
		title: "Estadísticas",
		ritualDuration: "Duración del Ritual",
		attendanceDuration: "Duración de las Atenciones",
		firstCall: "Primera Llamada",
		lastCall: "Última Llamada",
		avgIncremental: "Tiempo Medio (Bajo Demanda)",
		avgPreDefined: "Tiempo Medio (Fijas)",
		totalTickets: "Total de Fichas",
		cancelledTickets: "Canceladas",
		newPersons: "Personas Nuevas",
		minutes: "min",
		notAvailable: "N/D",
	},
	tickets: {
		title: "Fichas de Atención",
		code: "Ficha",
		person: "Consultante",
		createdAt: "Creación",
		calledAt: "Llamada",
		finishedAt: "Fin",
		elapsed: "Duración",
		status: "Estado",
		medium: "Médium",
		guide: "Guía",
		avgTime: "Tiempo medio",
		noTickets: "Sin fichas en este grupo",
	},
	messages: {
		title: "Mensajes",
		type: "Tipo",
		severity: "Severidad",
		message: "Mensaje",
		person: "Persona",
		createdBy: "Creado por",
	},
	returns: {
		fulfilledTitle: "Retornos Cumplidos en este Ritual",
		newTitle: "Nuevos Retornos",
		returnType: "Tipo",
		person: "Consultante",
		target: "Destino",
		status: "Estado",
		notes: "Observaciones",
		fulfilled: "Cumplido",
		pending: "Pendiente",
	},
	general: {
		title: "Informe General de Rituales",
		menuTitle: "Informe General",
		fetchError: "Error al cargar el informe",
		exportPdf: "Exportar PDF",
		pdfError: "Error al generar el PDF",
		minutesShort: "min",
		filters: {
			status: "Estado",
			allPeriods: "Todo el período",
		},
		empty: {
			title: "Ningún ritual en el período",
			description: "Ajusta el período o los estados seleccionados para ver los resultados.",
		},
		groups: {
			byRitual: "Visión por ritual",
			byType: "Distribución por tipo",
			mediums: "Desempeño de los médiums",
		},
		kpis: {
			rituals: "Rituales",
			completedTickets: "Atenciones",
			distinctPersons: "Personas atendidas",
			cancelledTickets: "Fichas canceladas",
			totalTime: "Tiempo total",
			avgTime: "Tiempo promedio",
		},
		charts: {
			ticketsByRitual: "Atenciones por ritual",
			ticketsByRitualType: "Atenciones por tipo de ritual",
			avgByRitualType: "Media de atenciones por tipo de ritual",
			ticketDistribution: "Distribución de fichas",
			topMediumsByTime: "Médiums con mayor tiempo de atención",
			topMediumsByAvg: "Médiums con mayor media de atenciones",
			attendances: "Atenciones",
			avgAttendances: "Media de atenciones",
			attendancesShort: "at.",
			tickets: "fichas",
			completed: "Concluidas",
			notCompleted: "No concluidas",
			cancelled: "Canceladas",
			totalTime: "Tiempo total",
		},
		byMedium: {
			title: "Por médium",
			medium: "Médium",
			attendances: "Atenciones",
			rituals: "Rituales",
			totalTime: "Tiempo total",
			avgTime: "Tiempo promedio",
			empty: "Ningún médium con atenciones en el período",
		},
		byGuide: {
			title: "Por guía",
			guide: "Guía",
			medium: "Médium",
			attendances: "Atenciones",
			totalTime: "Tiempo total",
			avgTime: "Tiempo promedio",
			empty: "Ninguna guía con atenciones en el período",
		},
	},
};
